export const camActionTypes = {
    pause: 'pause',
    stop: 'stop',
    prev: 'prev',
    nextOrPlay: 'nextOrPlay'
};
